module.exports = __webpack_public_path__ + "img/woman.7f0b03bc.svg";